/*
 * UKCL ATC feedback + REAL cart add.
 *
 * Replaces the previous purely-cosmetic version. Same visual look (teal
 * "Adding..." spinner -> white tick on success) but every state is now
 * gated on the actual /cart/add.js response. Real errors surface in red.
 *
 * Capture-phase click + submit interception fires BEFORE Empire's
 * bubble-phase AddToCartFlyout handlers, so the known-broken Empire
 * class never runs at all.
 *
 * Coverage:
 *   - Main PDP form: form[data-product-form][action*="/cart/add"]
 *
 * Deliberately SKIPPED (already work via their own code, don't double-handle):
 *   - Sticky bar button         (sections/ukcl-sticky-add-to-cart.liquid)
 *   - Quick-buy collection grid (snippets/ukcl-atc-global.liquid)
 *   - Quickshop modal forms     (snippets/ukcl-atc-global.liquid)
 *   - Shop Pay dynamic checkout (no data-product-form attribute on its form)
 */
(function() {
  'use strict';

  // Keyframes for the spinner
  var style = document.createElement('style');
  style.textContent = '@keyframes atcspin{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setSpinner(btn) {
    btn._ukclOrig = {
      bg: btn.style.backgroundColor || '',
      color: btn.style.color || '',
      html: btn.innerHTML
    };
    btn.style.backgroundColor = '#028a7e';
    btn.style.color = '#fff';
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;">'
                  + '<span style="display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,0.3);border-top:2px solid #fff;border-radius:50%;animation:atcspin 0.6s linear infinite;"></span> Adding...</span>';
  }
  function setTick(btn) {
    btn.style.backgroundColor = '#028a7e';
    btn.style.color = '#fff';
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px;">Added to Basket'
                  + ' <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg></span>';
  }
  function setError(btn, msg) {
    btn.style.backgroundColor = '#c62828';
    btn.style.color = '#fff';
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;">' + msg + '</span>';
  }
  function revert(btn) {
    if (!btn._ukclOrig) return;
    btn.style.backgroundColor = btn._ukclOrig.bg;
    btn.style.color = btn._ukclOrig.color;
    btn.innerHTML = btn._ukclOrig.html;
    btn.disabled = false;
    delete btn._ukclOrig;
  }
  function updateBadges(cart) {
    var count = (cart && cart.item_count) || 0;
    var badges = document.querySelectorAll('[data-ukcl-cart-count], [data-header-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      if (badges[i].dataset) badges[i].dataset.headerCartCount = count;
      if (count > 0) {
        badges[i].classList.add('visible');
        badges[i].classList.remove('ukcl-hidden');
      } else {
        badges[i].classList.remove('visible');
      }
    }
    try { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
  }
  function refreshCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  function isOurForm(form) {
    if (!form) return false;
    if (!form.matches || !form.matches('form[data-product-form][action*="/cart/add"]')) return false;
    if (form.closest('[data-modal-content]')) return false;
    if (form.closest('[data-ukcl-sticky-atc]')) return false;
    return true;
  }

  function submitForm(form, btn) {
    btn.disabled = true;
    setSpinner(btn);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin'
    })
    .then(function(resp) {
      if (!resp.ok) {
        return resp.json().then(
          function(err) { throw err; },
          function() { throw { description: 'HTTP ' + resp.status }; }
        );
      }
      return resp.json();
    })
    .then(function() { return refreshCart(); })
    .then(function(cart) {
      updateBadges(cart);
      setTick(btn);
      setTimeout(function() { revert(btn); }, 5000);
    })
    .catch(function(err) {
      var msg = (err && err.description) ? err.description
              : (err && err.message)     ? err.message
              :                            'Could not add';
      if (msg.length > 42) msg = msg.slice(0, 40) + '…';
      setError(btn, msg);
      setTimeout(function() { revert(btn); }, 3500);
    });
  }

  // Click intercept (capture phase, fires before Empire's bubble handlers)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[type=submit], input[type=submit]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('form');
    if (!isOurForm(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    submitForm(form, btn);
  }, true);

  // Submit intercept (capture phase) — covers Enter-key in a quantity input
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!isOurForm(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('button[type=submit]') || form.querySelector('input[type=submit]');
    if (!btn) return;
    submitForm(form, btn);
  }, true);

})();
